import { ComponentStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

export const DividerStyles: ComponentStyleConfig = {
  baseStyle: (props) => ({
    borderColor: mode('gray.100', 'gray.600')(props),
  }),
};
